import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from 'react-router-dom';

import './i18n/config';
import { productsRoute, PRODUCTS_PATH } from './pages/products';
import { wizardRoute } from './pages/wizard';

// Styles
import 'simple-css-reset/reset.css';
import './styles/index.css';

const routes = [
  productsRoute,
  wizardRoute,
  {
    index: true,
    path: '*',
    loader: () => redirect(PRODUCTS_PATH),
  },
];

const router = createBrowserRouter(routes, {
  // Supports PR deployments
  basename: process.env.REACT_APP_ROUTER_ROOT,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
